import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';

class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration({ featureFlags}) {
    return GridConfig.getDefaultConfiguration(featureFlags);
  }

  static getManifestNumberClass(params){
    return  params?.data && params.data.compliancePercentage >=  appConstants.DCR_DRILLDOWN_COMPLIANCE ?  "actionable-cell"  :"";
  }

  static getRouteType(params) {
    if (params.data.routeName === appConstants.UNRTD_ROUTENAME) {
      return "";
    }
    if (params.data.isTrap) {
      return appConstants.ROUTE_TYPES.TRAP;
    }
    return appConstants.ROUTE_TYPES.CITY;
  }

  static getDefaultConfiguration(featureFlags) {
    return {
      title: appConstants.gridNames.DockCompliance,
      suppressMenu: false,
      suppressSorting: false,
      defaultColDef: {
        sortable: true,
        resizable: false,
      },
      columns: [
        {
          headerName: "Compliance %",
          field: "compliancePercentage",
          headerTooltip: "Compliance",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Type",
          field: "type",
          headerTooltip: "Route Type",
          minWidth: appConstants.columnWidth.DCR_ROUTETYPE,
          // valueFormatter: GridConfig.getRouteType,
          filter: MultiSelectFilter,
          /* filterParams: {
            staticOptions: appConstants.ROUTE_TYPES_LIST,
          },
          filterValueGetter:
            GridConfig.getRouteType,*/
        },
        {
          headerName: "Planned Route",
          field: "plannedRoute",
          headerTooltip: "Planned Route",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Dispatched Route",
          field: "dispatchedRoute",
          headerTooltip: "Dispatched Route",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_DROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Manifest #",
          field: "manifestNumber",
          headerTooltip: "Manifest #",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_MANIFEST,
          cellClass: GridConfig.getManifestNumberClass,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Planned Bills",
          field: "plannedBills",
          headerTooltip: "Planned Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Matched Bills",
          field: "matchedBills",
          headerTooltip: "Matched Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_MATCHED,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Wrong FMRT",
          field: "wrongFmrt",
          headerTooltip: "Wrong Loading Zone",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_MATCHED,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Loaded Bills",
          field: "loadedBills",
          headerTooltip: "Loaded Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Matched Bills",
          field: "matchedBills",
          headerTooltip: "Matched Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_MATCHED,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Missed Bills",
          field: "missedBills",
          headerTooltip: "Missed Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Extra Bills",
          field: "extraBills",
          headerTooltip: "Extra Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_MANIFEST,
          filter: MultiSelectFilter,
        },
        {
          headerName: "No RMAX Route",
          field: "noRmaxRoute",
          headerTooltip: "Unplanned Bills",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_UNPL,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Planned PSE",
          field: "plannedPse",
          headerTooltip: "Planned PSE",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
          hide: featureFlags.IsWeightBasedRoutingEnabled
        },
        {
          headerName: "Loaded PSE",
          field: "loadedPse",
          headerTooltip: "Loaded PSE",
          minWidth: appConstants.columnWidth.DCR_COMPLIANCE_PROUTE,
          filter: MultiSelectFilter,
          hide: featureFlags.IsWeightBasedRoutingEnabled
        },
      ],
    };
  }
}

export default GridConfig;
